import React, { useMemo } from "react";
import { Grid, Autocomplete, TextField } from "@mui/material";
import { seriesOptions, variantOptions } from "../constants/closetOptions";

const DecoOptions = ({
  decoStyle,
  selectedSeries,
  setSelectedSeries,
  selectedVariant,
  setSelectedVariant,
  columns = 2,
}) => {
  const validDecoStyles = useMemo(() => Object.keys(seriesOptions), []);
  const isValidDecoStyle = validDecoStyles.includes(decoStyle);

  const availableSeries = useMemo(
    () => seriesOptions[decoStyle] || [],
    [decoStyle]
  );

  const availableVariants = useMemo(
    () => (decoStyle === "5-Piece" ? [] : variantOptions[selectedSeries] || []),
    [decoStyle, selectedSeries]
  );

  if (!isValidDecoStyle) return null;

  return (
    <>
      <Grid item xs={12 / columns}>
        <Autocomplete
          options={availableSeries}
          value={availableSeries.includes(selectedSeries) ? selectedSeries : null}
          onChange={(_, val) => setSelectedSeries(val || "")}
          renderInput={(params) => (
            <TextField {...params} label="Series" fullWidth error={!selectedSeries} />
          )}
        />
      </Grid>

      {selectedSeries && decoStyle !== "5-Piece" && (
        <Grid item xs={12 / columns}>
          <Autocomplete
            options={availableVariants}
            value={availableVariants.includes(selectedVariant) ? selectedVariant : null}
            onChange={(_, val) => setSelectedVariant(val || "")}
            renderInput={(params) => (
              <TextField {...params} label="Variant" fullWidth error={!selectedVariant} />
            )}
          />
        </Grid>
      )}
    </>
  );
};

export default DecoOptions;
